"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _utils from "./utils";
import _styles from "./TopNavItem.module.css";

export function TopNavItem({
  as: _Component = _Builtin.NavbarLink,
  text = "Features",
  runtimeProps = {},
}) {
  return (
    <_Component
      className={_utils.cx(_styles, "navbar-link")}
      options={{
        href: "#",
      }}
      {...runtimeProps}
    >
      {text}
    </_Component>
  );
}
